export default __webpack_public_path__ + "static/media/Trichy-Tanjore-diocese.153100dd.png";